require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./main-tendue-1-9-9.json") })
        }
      }, "path---main-tendue-1-9-9");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---main-tendue-1-9-9!./.cache/json/main-tendue-1-9-9.json
// module id = 484
// module chunks = 231608221292675